import { InlineEditor } from "./InlineEditor";
import type { EditorProps } from "./editorProps";

export const TextEditor = (props: EditorProps) => (
    <InlineEditor {...props} align="start" />
);
